import { Injectable } from "@angular/core";
import { AfericaoCatraca } from "@tivic-team/manager-ts/dist/mob/entities/concessao/afericao-catraca.entity";
import { AfericaoCatracaController } from "app/controllers/mob/afericao-catraca.controller";
import { AfericaoCatracaDTO, AfericaoCatracaListDTO } from "app/model/dtos/mob/afericao-catraca.dto";
import { LoaderService } from "../loader.service";
import { AfericaoCatracaSearch } from "./afericao-catraca.search";


@Injectable({
    providedIn: "root",
})

export class AfericaoCatracaService {
    constructor(
        private _afericaoCatracaController: AfericaoCatracaController,
        private _loaderService: LoaderService
    ) { }

    async save(afericaoCatracaDTO: AfericaoCatracaDTO): Promise<AfericaoCatracaDTO> {
        this._loaderService.show();
        if (afericaoCatracaDTO.cdAfericaoCatraca && afericaoCatracaDTO.cdAfericaoCatraca > 0)
            return this._afericaoCatracaController.update(afericaoCatracaDTO).finally(() => this._loaderService.hide());
        else
            return this._afericaoCatracaController.create(afericaoCatracaDTO).finally(() => this._loaderService.hide());
    }

    async get(cdAfericaoCatraca: number): Promise<AfericaoCatracaDTO> {
        this._loaderService.show();
        return this._afericaoCatracaController.get(cdAfericaoCatraca).finally(() => this._loaderService.hide());
    }

    async find(afericaoCatracaSearch?: AfericaoCatracaSearch): Promise<Array<AfericaoCatracaDTO>> {
        this._loaderService.show();
        try {
            return await this._afericaoCatracaController.find((afericaoCatracaSearch && afericaoCatracaSearch.getFilters()) || null)
                .finally(() => this._loaderService.hide());
        } catch (error) {
            this._loaderService.hide();
            return [];
        }
    }

    async buscar(afericaoCatracaSearch?: AfericaoCatracaSearch): Promise<AfericaoCatracaListDTO> {
        this._loaderService.show();
        try {
            return await this._afericaoCatracaController.buscar((afericaoCatracaSearch && afericaoCatracaSearch.getFilters()) || null)
                .finally(() => this._loaderService.hide());
        } catch (error) {
            this._loaderService.hide();
            return new AfericaoCatracaListDTO();
        }
    }

    async buscarLacracao(afericaoCatracaSearch?: AfericaoCatracaSearch): Promise<AfericaoCatracaListDTO> {
        this._loaderService.show();
            return this._afericaoCatracaController.buscarLacracao((afericaoCatracaSearch && afericaoCatracaSearch.getFilters()) || null)
                .finally(() => this._loaderService.hide());
    }


    async getRelatorio(afericaoCatracaSearch: AfericaoCatracaSearch): Promise<Blob> {
        this._loaderService.show();
        try {
          return await this._afericaoCatracaController.getRelatorio((afericaoCatracaSearch && afericaoCatracaSearch.getFilters()) || null).finally(() => this._loaderService.hide())
        } catch (error) {
          this._loaderService.hide();
          return null
        }
      }

    async getDataUltimaAfericao(nrPrefixo: number): Promise<AfericaoCatraca> {
        this._loaderService.show();
        return this._afericaoCatracaController.getDataUltimaAfericao(nrPrefixo).finally(() => this._loaderService.hide());
    }
}